<template>
    <section :style="{ marginTop: '20px' }">
      <CampaignsTable
          :dataSource="events"
          :loading="loading"
          @pagination="pagination"
      ></CampaignsTable>
    </section>
</template>
<script>
import CampaignsTable from "@/components/Campaigns/CampaignsTable.vue";
import {mapGetters} from "vuex";

export default {
  components: { CampaignsTable },
  data() {
    return {
      loading: true
    };
  },
  methods: {
    async dispatchActions(page = 1) {
      this.loading = true;
      await this.$store.dispatch("events/FAILED_EVENTS", { page: page, context: this });
    },
    pagination: function(page) {
      this.dispatchActions(page);
    }
  },
  computed: {
    ...mapGetters({
      events: "events/getData"
    })
  },
  mounted() {
    this.dispatchActions();
  }
};
</script>